export default "__VITE_ASSET__Dfn6mOKE__"